// @flow

// "meta" as in meta information about the page (not "meta" commerce stuff)

import type { Action as AllActions } from './state';
import { SET_HOTELS_DATES_GUESTS } from './travelerInfo/hotels';

const VIEWPORT_CATEGORY_CHANGE = 'VIEWPORT_CATEGORY_CHANGE';
export const viewportCategoryChange = (viewportCategory: ?string) => ({
  type: VIEWPORT_CATEGORY_CHANGE,
  viewportCategory,
});

export type ViewportCategory = 'MOBILE' | 'TABLET' | 'DESKTOP';
export type UserAgentCategory = 'MOBILE' | 'TABLET' | 'DESKTOP';
export type OSType = 'ANDROID' | 'IOS' | 'UNKNOWN';
export type BrowserType = 'CHROME' | 'IE' | 'SAFARI' | 'UNKNOWN';

type Device = {|
  /**
   * The current responsive breakpoint based on viewport dimensions. This can change after page load if the viewport is
   * resized or orientation changed
   */
  viewportCategory: ViewportCategory,

  /** Categorization of the user's device based on User Agent string alone. Should not change with viewport size changes. */
  userAgentCategory: UserAgentCategory,

  os: {
    family: OSType,
    majorVersion: number,
  },
  browser: {
    family: BrowserType,
    majorVersion: number,
  },

  securityToken: string,
|};

export type State = {|
  initialServletName: string | null,
  device: Device,
  readonlyMode: boolean,
  initialRelativeUrl: string,
  initialAbsoluteUrl: ?string,
  baseUrl: string,
  cookieDomain: string,
  forceFullSite: boolean,
  imageCdnUrl: string,
  mediaCdnUrl: string,
  isTaReferrer: boolean,
  referrerUrl: ?string,
  environment: string | null,
  isNativeWebview: boolean,
  commerceCountryId: number,
  lineItemsByLoc: ?{ [string]: string },
  taUnique: string,
|};

export const emptyState = () => ({
  initialServletName: null,
  device: {
    viewportCategory: 'MOBILE',
    userAgentCategory: 'MOBILE',
    os: {
      family: 'UNKNOWN',
      majorVersion: -1,
    },
    browser: {
      family: 'UNKNOWN',
      majorVersion: -1,
    },
    securityToken: '',
  },
  readonlyMode: false,
  initialRelativeUrl: '/',
  initialAbsoluteUrl: null, // Should never be null but better to not hard-code a URL.
  baseUrl: '', // Should never be null but better to not hard-code a URL.
  cookieDomain: '',
  forceFullSite: false,
  imageCdnUrl: '',
  mediaCdnUrl: '',
  isTaReferrer: false,
  referrerUrl: '',
  environment: null,
  isNativeWebview: false,
  commerceCountryId: 0,
  lineItemsByLoc: null,
  taUnique: '',
});

export default (state: State = emptyState(), action: AllActions): State => {
  switch (action.type) {
    case VIEWPORT_CATEGORY_CHANGE:
      return {
        ...state,
        device: { ...state.device, viewportCategory: action.viewportCategory },
      };
    case SET_HOTELS_DATES_GUESTS:
      return {
        ...state,
        lineItemsByLoc: null,
      };
    default:
      return state;
  }
};
